import styled from 'styled-components'

export const Gradient = styled.div`
  background: rgb(170, 170, 170);
  background: linear-gradient(180deg, rgba(170, 170, 170, 1) 0%, rgba(34, 33, 33, 0) 100%);
`
